module.exports = __webpack_public_path__ + "static/SME-948ac45d359ce53f24cbcdd00b888612.svg";